import { render } from "./CreateAdmin.vue?vue&type=template&id=59570404&scoped=true"
import script from "./CreateAdmin.vue?vue&type=script&lang=js"
export * from "./CreateAdmin.vue?vue&type=script&lang=js"

import "./CreateAdmin.vue?vue&type=style&index=0&id=59570404&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59570404"]])

export default __exports__